import { useEffect } from 'react';
import PageHeader from '../../components/PageHeader';
import { Icon } from '../../components/Icons';
import { RESEARCH_LIFE } from '../../config/data';
import ArckBanner from '../../components/ArckBanner';
import { t } from '../../utils/i18n';
import '../ResearchAgentPage/index.css';
import './index.css';

export default function LifeSciencePage() {
    useEffect(() => {
        document.title = t('生命科学 · 至知创新研究院', 'Life Sciences · IQuest Research');
    }, []);
    return (
        <div className="page-shell">
            <PageHeader
                eyebrow={t('生命科学 · Life Sciences', 'Life Sciences')}
                title={t(
                    '自主智能生物大模型，从分子设计到实验验证全程自主闭环',
                    'Autonomous bio‑foundation model: A fully autonomous closed loop from molecular design to experimental validation'
                )}
                subtitle={t(
                    '坚持 End-First 思考，用顶尖科学计算与全栈技术体系，定义生命科学智能研发新高度。',
                    'Guided by End‑First thinking, we leverage cutting‑edge scientific computing and a full‑stack technology system to redefine the intelligent R&D in life sciences.'
                )}
            />
            {RESEARCH_LIFE.map((item, idx) => {
                const features = item?.back ?? [];
                return (
                    <section
                        className={`section research-detail-section life-detail-section${idx % 2 === 1 ? ' is-soft' : ''}`}
                        key={item.id ?? idx}
                    >
                        <div className="container">
                            <div className="life-detail-eyebrow">
                                Module · 0{idx + 1}
                            </div>
                            <div className="research-split">
                                <div className="research-split-left">
                                    <div className="research-split-card">
                                        <div className="research-split-img">
                                            {item.img && <img src={item.img} alt={item.title} loading="lazy" decoding="async" />}
                                        </div>
                                        <div className="research-split-card-body">
                                            <div className="research-split-card-title">{item.title}</div>
                                            <p className="research-split-card-desc">{item.desc}</p>
                                            {item.href && (
                                                <a
                                                    className="btn btn-secondary project-link life-detail-link"
                                                    href={item.href}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {t('访问项目', 'Learn More')}
                                                    <Icon name="arrowRight" width={16} height={16} aria-hidden />
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="research-split-right">
                                    {features.map((feature, fIdx) => (
                                        <div className="research-feature-item" key={feature.title ?? fIdx}>
                                            <div className="research-feature-icon">
                                                <Icon name={feature.iconName ?? 'sparkles'} width={20} height={20} />
                                            </div>
                                            <div className="research-feature-body">
                                                <div className="research-feature-title">{feature.title}</div>
                                                <p className="research-feature-desc">{feature.desc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                );
            })}

            <ArckBanner />
        </div>
    );
}
